import { createReducer, createAction, PayloadAction } from '@reduxjs/toolkit'
import { Lesson } from '../types'

export interface LessonReducer {
  lesson: Lesson | null
}

const initialState: LessonReducer = {
  lesson: null
}

interface FetchLessonPayload {
  id: string
}
export type FetchLessonAction = PayloadAction<FetchLessonPayload>
export const FETCH_LESSON = createAction<FetchLessonPayload>('lesson_reducer/fetch_lesson')
export const FETCH_LESSON_SUCCESS = createAction<Lesson>('lesson_reducer/fetch_lesson_success')
export const FETCH_LESSON_FAIL = createAction('lesson_reducer/fetch_lesson_fail')
export const CLEAR_LESSON = createAction('lesson_reducer/clear_lesson')

interface ExtendLessonPayload {
  id: string
}
export type ExtendLessonAction = PayloadAction<ExtendLessonPayload>
export const EXTEND_LESSON = createAction<ExtendLessonPayload>('lesson_reducer/extend_lesson')
export const EXTEND_LESSON_SUCCESS = createAction<Lesson>('lesson_reducer/extend_lesson_success')
export const EXTEND_LESSON_FAIL = createAction('lesson_reducer/extend_lesson_fail')

export const lessonReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(FETCH_LESSON_SUCCESS, (state, action) => {
      return { ...state, lesson: action.payload }
    })
    .addCase(CLEAR_LESSON, (state) => {
      return initialState
    })
    .addCase(EXTEND_LESSON_SUCCESS, (state, action) => {
      return { ...state, lesson: action.payload }
    })
})
